import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ViewChild,
  computed,
  model,
  signal,
  ElementRef,
  inject,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { UniversalSearchService } from '../../../../universal-search/services/universal-search.service';
import { CustomFiltersService } from '../../../../services/custom-filters.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { RightBridgeApiService } from '../../../../services/right-bridge-api.service';
import { Subject } from 'rxjs';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminService } from '../../../../admin/admin.service';

@Component({
  selector: 'app-chip-filter',
  templateUrl: './chip-filter.component.html',
  styleUrls: ['./chip-filter.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    MatChipsModule,
    MatTooltipModule,
  ],
})
export class ChipFilterComponent implements OnInit, OnDestroy {
  cstmFltrSrvc = inject(CustomFiltersService);
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  private adminService = inject(AdminService);
  usServ = inject(UniversalSearchService);

  @ViewChild(MatAutocompleteTrigger) chipFilterAuto: MatAutocompleteTrigger;
  @ViewChild('chipInput') chipInput: ElementRef;

  @Input() field;
  @Input() filterForm;
  @Input() groupKey;
  @Output() selectionChange = new EventEmitter();
  @Output() clearFilter = new EventEmitter();
  unsubscribe = new Subject();
  dropdownLoading: boolean = false;
  globals = this.ss.get('globals');
  dropdownNoResults: boolean;
  previousSelectedVal = '';

  chips = signal([]);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  currentChip = model('');
  chipOptions = signal([]);
  filteredChips = computed(() => {
    const currentChip = this.currentChip().toLowerCase();
    return currentChip
      ? this.chipOptions().filter(
          chip =>
            chip.value?.toLowerCase().includes(currentChip) ||
            chip.display?.toLowerCase().includes(currentChip) ||
            chip.BridgeID?.toLowerCase().includes(currentChip) ||
            chip.BridgeName?.toLowerCase().includes(currentChip)
        )
      : this.chipOptions().slice();
  });
  requestRepsSearch = false;
  dropdownRepCodes = [];

  ngOnInit(): void {
    this.cstmFltrSrvc.updateDropdowns$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: field => {
          if (field) {
            if (
              field['field'] === this.field.varName &&
              (typeof field['value'] === 'number' || field['value'])
            ) {
              if (Array.isArray(field['value'])) {
                const chipValues = [];
                field['value'].map(chip => {
                  chipValues.push(
                    this.chipOptions().find(
                      chipOpt => chipOpt['value'] === chip
                    )?.display
                  );
                });
                this.chips.set(chipValues);
                this.filterForm.controls[this.groupKey].controls[
                  this.field.varName
                ].setValue(field['value']);
              } else {
                this.chips.set([field['value']]);
                this.chips.set([field['values']['value']]);
                this.filterForm.controls[this.groupKey].controls[
                  this.field.varName
                ].setValue([field['values']['value']]);
              }
            } else if (
              field['varName'] === this.field.varName &&
              field['values']?.['value']
            ) {
              if (Array.isArray(field['values']['value'])) {
                if (this.field.controlType === 'repCodeMulti') {
                  if (this.chipOptions().length <= 0) {
                    this.getRepCodeOptions(field['values']['value']);
                  }
                } else if (this.field.controlType === 'unitMulti') {
                  if (this.chipOptions().length <= 0) {
                    this.getUnitOptions(field['values']['value']);
                  }
                } else if (this.field.controlType === 'bridgeidselect') {
                  this.chips.set(
                    this.parseChipValues(field['values']['value'], 'BridgeID')
                  );
                  this.filterForm.controls[this.groupKey].controls[
                    this.field.varName
                  ].setValue(field['values']['value']);
                } else {
                  this.chips.set(
                    this.parseChipValues(field['values']['value'], 'value')
                  );
                  this.filterForm.controls[this.groupKey].controls[
                    this.field.varName
                  ].setValue(field['values']['value']);
                }
              } else {
                this.chips.set(
                  this.parseChipValues(field['values']['value'], 'value')
                );
                this.filterForm.controls[this.groupKey].controls[
                  this.field.varName
                ].setValue([field['values']['value']]);
              }
            } else if (
              (field['varName'] === this.field.varName &&
                !field['values']?.['value']) ||
              (field['values']?.['field'] === this.field.varName &&
                !field['values']?.['value'])
            ) {
              this.chips.set([]);
              this.filterForm.controls[this.groupKey].controls[
                this.field.varName
              ].setValue([]);
            }
          }
        },
        error: err => {
          console.error('Error: ', err);
        },
      });

    this.setChipOptions();

    this.cstmFltrSrvc.reloadFilters$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: () => {
          this.setChipOptions();
        },
        error: error => alert(error),
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  parseChipValues(values, keyName) {
    if (this.chipOptions().length <= 1) {
      this.setChipOptions();
    }

    const chipValues = [];

    values.map(chip => {
      chipValues.push(
        this.chipOptions().find(chipOpt => chipOpt[keyName] === chip)?.[keyName]
      );
    });

    return chipValues;
  }

  setChipOptions() {
    if (this.field.controlType === 'repCodeMulti') {
      if (this.chipOptions().length <= 0) {
        this.getRepCodeOptions();
      }
    } else if (this.field.controlType === 'unitMulti') {
      if (this.chipOptions().length <= 0) {
        this.getUnitOptions();
      }
    } else if (this.field.options) {
      this.chipOptions.set(this.field.options);
    }
  }

  getRepCodeOptions(setValues?) {
    this.dropdownLoading = true;
    this.dropdownRepCodes = this.ss.get('repUnits');
    if (
      this.globals &&
      this.globals.user.managerUnitCount &&
      this.globals.user.managerUnitCount > 0
    ) {
      this.requestRepsSearch = true;
    } else {
      this.requestRepsSearch = false;
    }

    this.rbs.getRepCodes('%', 9999).subscribe(res => {
      if (this.requestRepsSearch) {
        this.dropdownRepCodes = res.names;
      }
      this.chipOptions.set(
        this.dropdownRepCodes.map(x => {
          return { value: x.repCode, display: `${x.name}: ${x.repCode}` };
        })
      );

      if (setValues) {
        const chipValues = [];
        setValues.map(chip => {
          chipValues.push(
            this.chipOptions().find(chipOpt => chipOpt['value'] === chip)
              ?.display
          );
        });
        this.chips.set(chipValues);
        this.filterForm.controls[this.groupKey].controls[
          this.field.varName
        ].setValue(setValues);
      }
      this.dropdownLoading = false;
    });
  }

  getUnitOptions(setValues?) {
    this.dropdownLoading = true;
    this.adminService.getUnitList('', true).subscribe(resp => {
      this.chipOptions.set(
        resp.names.map(unitObj => ({
          value: unitObj.id,
          display: unitObj.name,
        }))
      );

      if (setValues) {
        const chipValues = [];
        setValues.map(chip => {
          chipValues.push(
            this.chipOptions().find(chipOpt => chipOpt['value'] === chip)
              ?.display
          );
        });
        this.chips.set(chipValues);
        this.filterForm.controls[this.groupKey].controls[
          this.field.varName
        ].setValue(setValues);
      }
      this.dropdownLoading = false;
    });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.chips.update(chips => [...chips, value]);
    }

    // Clear the input value
    this.currentChip.set('');
    this.chipInput.nativeElement.value = '';
  }

  remove(fruit: string): void {
    this.chips.update(chips => {
      const index = chips.indexOf(fruit);
      if (index < 0) {
        return chips;
      }

      chips.splice(index, 1);
      return [...chips];
    });

    this.selectionChange.emit({
      option: {
        value: this.chips(),
      },
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (
      this.field.controlType === 'chip' ||
      this.field.controlType === 'repCodeMulti' ||
      this.field.controlType === 'unitMulti'
    ) {
      if (!this.chips().includes(event.option.viewValue)) {
        const chipValues = [];
        this.chips.update(chips => [...chips, event.option.viewValue]);
        this.chips().map(chip => {
          chipValues.push(
            this.chipOptions().find(chipOpt => chipOpt['display'] === chip)
              ?.value
          );
        });
        this.selectionChange.emit({
          option: {
            value: chipValues,
          },
        });
      }
    } else if (this.field.controlType === 'bridgeidselect') {
      if (!this.chips().includes(event.option.value)) {
        this.chips.update(chips => [...chips, event.option.value]);
        this.selectionChange.emit({
          option: {
            value: this.chips(),
          },
        });
      }
    }
    this.currentChip.set('');
    this.chipInput.nativeElement.value = '';
    event.option.deselect();
  }

  getOpportunityDisplay(formItem) {
    if (this.field.options.length) {
      return this.field.options.find(opt => formItem === opt.BridgeID)
        ?.BridgeName;
    }
  }

  onBlur() {
    setTimeout(() => {
      this.chipFilterAuto.autocomplete.showPanel = false;
    }, 250);
  }
}
